import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import {P, H5 } from "../../../AbstractElements";
import Swal from "sweetalert2";

//DataTable
import { ApplicationsTableColumn } from "../../../Data/DataTables/Applications";

//Types
import { ViewCandidatesByStatus } from "../../../Types/Applicants/Candidates";

//Services
import {
    VIEW_CANDIDATES_QUERY_KEY,
    applicantsService,
} from "../../../Services/applicantsService";

interface ModuleProps {
  ApplStatus: string;
  Title: string;
  Desc: string;
}

const ApplicationTable: React.FC<ModuleProps> = ({
  Title,
  Desc,
  ApplStatus
}) => {
    const customStyles = {
        rows: {
            style: {
                whiteSpace: "nowrap",
            },
        },
        cells: {
            style: {
                whiteSpace: "nowrap",
                marginTop: "8px",
                marginBottom: "8px",
            },
        },
    };

    const [filterText, setFilterText] = useState("");

    const QueryKey = [...VIEW_CANDIDATES_QUERY_KEY];

    const { data: candidatesData = [], isLoading: CandidatesisLoading } =
        useQuery<ViewCandidatesByStatus[]>({
            queryKey: QueryKey,
            queryFn: () => applicantsService.getAllByStatus(ApplStatus),
    });

    const filteredItems: ViewCandidatesByStatus[] = candidatesData.filter(
        (item) =>
            Object.values(item).some(
            (value) =>
                value &&
                value.toString().toLowerCase().includes(filterText.toLowerCase())
        )
    );

    return (
        <>
        <H5 className="mb-0">{Title}</H5>
        <P className="mb-3 f-light f-w-200 f-12"> {Desc} </P>
            <FilterComponent
                onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFilterText(e.target.value)
                }
                filterText={filterText}
            />
            <div className="table-responsive theme-scrollbar">
                <DataTable
                    className="display nowrap custom-scrollbar"
                    data={filteredItems}
                    columns={ApplicationsTableColumn}
                    striped={true}
                    pagination
                    progressPending={CandidatesisLoading}
                    highlightOnHover={true}
                    fixedHeader={true}
                    customStyles={customStyles}
                />
            </div>
        </>
    );
};

export default ApplicationTable;
